import { useState } from 'react';

import type { Notification } from '@enterprise/api';
import { isEmpty, isNotDefined } from '@enterprise/core';

import type { NotificationTab } from '../components/notification-tabs/types/notification-tab.type';
import type { NotificationPanelConfiguration } from './types/notification-panel-configuration.type';

export const useNotificationPanelConfiguration = (notifications: Notification[]): NotificationPanelConfiguration => {
  const [activeTab, setActiveTab] = useState<NotificationTab>('all');

  const unreadCount = notifications.filter((notification) => {
    return isNotDefined(notification.readDate);
  }).length;

  const errorCount = notifications.filter((notification) => {
    return notification.outcome === 'failed';
  }).length;

  const counts = {
    all: notifications.length,
    errors: errorCount,
    unread: unreadCount,
  };

  const getFilteredNotifications = (): Notification[] => {
    if (activeTab === 'unread') {
      return notifications.filter((notification) => {
        return isNotDefined(notification.readDate);
      });
    }

    if (activeTab === 'errors') {
      return notifications.filter((notification) => {
        return notification.outcome === 'failed';
      });
    }

    return notifications;
  };

  const filtered = getFilteredNotifications();
  const hasUnread = unreadCount > 0;
  const isPanelEmpty = isEmpty(filtered);
  const isDeleteAllDisabled = isEmpty(notifications);
  const isReadAllDisabled = !hasUnread;

  const onTabChange = (tab: NotificationTab) => {
    setActiveTab(tab);
  };

  return {
    activeTab,
    counts,
    filtered,
    hasUnread,
    isDeleteAllDisabled,
    isPanelEmpty,
    isReadAllDisabled,
    onTabChange,
  };
};
